import { render } from "./SimsTable.vue?vue&type=template&id=32733847&scoped=true"
import script from "./SimsTable.vue?vue&type=script&lang=js"
export * from "./SimsTable.vue?vue&type=script&lang=js"

import "./SimsTable.vue?vue&type=style&index=0&id=32733847&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32733847"]])

export default __exports__